export const setStyleProperty = (prop: string, value: string) => {
  document.documentElement.style.setProperty(prop, value);
};
